import type { RequiredReactRendererDependencies } from '@mail/3promo/render/react/dependencies';
import React, { type PropsWithChildren, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from 'reactApp/store';

type ReactRendererCbWrapperProps = PropsWithChildren<{ onMount?: () => void; onUnmount?: () => void }>;

const ReactRendererCbWrapper = ({ children, onMount, onUnmount }: ReactRendererCbWrapperProps) => {
    useEffect(() => {
        onMount?.();
        return onUnmount;
    }, []);

    return <Provider store={store}>{children}</Provider>;
};

const roots = new Map<HTMLElement, HTMLElement>();

export const defaultReactRenderDeps: RequiredReactRendererDependencies = {
    reactRender: (tsx, rootElement, callback) => {
        if (!roots.has(rootElement)) {
            const container = document.createElement('div');
            rootElement.appendChild(container);
            roots.set(rootElement, container);
        }
        const container = roots.get(rootElement)!;

        ReactDOM.render(
            <ReactRendererCbWrapper onMount={callback} onUnmount={() => roots.delete(rootElement)}>
                {tsx}
            </ReactRendererCbWrapper>,
            container
        );
    },
    reactUnmount: (rootElement) => {
        const container = roots.get(rootElement);
        if (!container) {
            return;
        }
        ReactDOM.unmountComponentAtNode(container);
        rootElement.removeChild(container);
        roots.delete(rootElement);
    },
};
